import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";

function Form() {
    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.gci_company_id) {
        hiddenValues.gci_company_id = profileFilter.gci_company_id
    }

    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/real-state/save`,
        endpointGetAllCities: `${endpointBackend}gci/cities/getall`,
        endpointGetById: `${endpointBackend}gci/real-state/getById`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
        urlGoBack: `/gci/real-state/list`,
        pathView: `/gci/real-state/view`
    }

    const labels = {
        labelTitleAdd: "Nova Imobiliária",
        labelTitleEdit: "Editar Imobiliária",
        labelTitleView: 'Visualizar Imobiliária'
    }

    const getForm = (values) => {

        let form = {
            hiddenValues,
            fields: [
                !profileFilter.gci_company_id ? {
                    name: 'gci_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                } : {},
                {
                    name: 'document_type',
                    type: 'select',
                    label: 'Tipo de Documento',
                    options: [
                        { label: 'CPF', value: 'CPF' },
                        { label: 'CNPJ', value: 'CNPJ' },
                    ],
                    validations: {
                        required: true
                    },
                    handleChange: async (element, field, values) => {
                        values.document = '';
                        const form = getForm(values);
                        form.values = values;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 6
                },
                {
                    name: 'document',
                    type: values.document_type,
                    label: values.document_type,
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                values.document_type === 'CNPJ' ? {
                    name: 'estadual_registration',
                    type: 'text',
                    label: 'Inscrição Estadual',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                } : {},
                {
                    name: 'name',
                    type: 'text',
                    label: values.document_type === 'CPF' ? 'Nome' : 'Razão Social',
                    validations: {
                        required: true
                    },
                    columnSize: values.document_type === 'CNPJ' ? 4 : 6
                },
                values.document_type === 'CNPJ' ? {
                    name: 'fantasy_name',
                    type: 'text',
                    label: 'Nome Fantasia',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                } : {},
                {
                    name: 'creci',
                    type: 'text',
                    label: 'CRECI',
                    validations: {
                        required: true
                    },
                    columnSize: values.document_type === 'CNPJ' ? 4 : 6
                },
                {
                    name: 'phone',
                    type: 'phone',
                    label: 'Telefone',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'email',
                    type: 'email',
                    label: 'Email',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'city_id',
                    type: 'select',
                    label: 'Município',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCities,
                        label: 'city_name',
                        value: 'city_id',
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'address',
                    type: 'address',
                    label: 'Endereço',
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    autocomplete: true,
                    hasComplement: true
                },
                {
                    name: 'observation',
                    type: 'textarea',
                    label: 'Observações',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels,
        }

        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            values.document_type = values.document_type || 'CPF';

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}

export default Form;
